/* Stranica proizvoda: procjena dostave i plutajući gumb "Dodaj u košaricu" */
(() => {
  if (window.__blProduct) return;
  window.__blProduct = true;

  const fmt = new Intl.DateTimeFormat('hr-HR', { weekday: 'short', day: 'numeric', month: 'numeric', timeZone: 'Europe/Zagreb' });

  function addWorkingDays(from, days) {
    const d = new Date(from);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  }

  function initEta(root = document) {
    root.querySelectorAll('[data-bl-eta]').forEach((el) => {
      const min = parseInt(el.dataset.min, 10) || 1;
      const max = Math.max(min, parseInt(el.dataset.max, 10) || min);
      const now = new Date();
      const a = addWorkingDays(now, min);
      const b = addWorkingDays(now, max);
      const out = el.querySelector('[data-bl-eta-range]');
      if (!out) return;
      out.textContent = min === max ? fmt.format(a) : `${fmt.format(a)} – ${fmt.format(b)}`;
    });
  }

  function initSticky(root = document) {
    const bar = root.querySelector('[data-bl-satc]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    const scope = bar.closest('.product-information') || document;
    const realBtn = () => scope.querySelector('button[name="add"]');
    const target = scope.querySelector('product-form-component') || realBtn();
    // Fixed traka mora biti izvan sticky/transform roditelja, inače završi ispod drugih sekcija
    if (!window.Shopify?.designMode) document.body.appendChild(bar);
    const priceOut = bar.querySelector('[data-bl-satc-price]');
    const btn = bar.querySelector('[data-bl-satc-btn]');
    if (!target) return;

    bar.hidden = false;

    const sync = () => {
      const p = scope.querySelector('product-price .price');
      if (p && priceOut) priceOut.textContent = p.textContent.trim();
      const r = realBtn();
      if (r && btn) btn.disabled = r.disabled;
    };

    const io = new IntersectionObserver(
      ([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        if (passed) sync();
        bar.classList.toggle('is-visible', passed);
      },
      { threshold: 0 }
    );
    io.observe(target);

    // Košarica je "page" tip pa dodavanje nema vidljivu potvrdu dolje na ekranu – prikazujemo je na samom gumbu
    const label = btn?.textContent.trim() || '';
    const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;
    let pending = false;
    let resetTimer;

    const setState = (state, text) => {
      if (!btn) return;
      btn.classList.remove('is-loading', 'is-added');
      if (state) btn.classList.add(state);
      btn.textContent = text;
    };

    const reset = () => {
      pending = false;
      setState('', label);
    };

    document.addEventListener('cart:update', (e) => {
      if (!pending) return;
      pending = false;
      clearTimeout(resetTimer);
      if (e.detail?.data?.didError) {
        reset();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      setState('is-added', '✓ Dodano – idi na košaricu');
      resetTimer = setTimeout(reset, 8000);
    });

    document.addEventListener('cart:error', () => {
      if (!pending) return;
      clearTimeout(resetTimer);
      reset();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    btn?.addEventListener('click', () => {
      if (btn.classList.contains('is-added')) {
        window.location.href = cartUrl;
        return;
      }
      if (pending) return;
      const r = realBtn();
      if (r && !r.disabled) {
        pending = true;
        setState('is-loading', 'Dodajem…');
        resetTimer = setTimeout(reset, 8000);
        r.click();
      } else {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  // Gumb aplikacije Releasit ima inline !important stilove pa ih usklađujemo iz JS-a (boja ostaje iz aplikacije)
  function styleCodButton() {
    const btn = document.querySelector('.product-information #_rsi-buy-now-button');
    if (!btn) return false;
    const apply = () => {
      if (btn.style.getPropertyValue('border-radius') === '999px') return;
      btn.style.setProperty('border-radius', '999px', 'important');
      btn.style.setProperty('min-height', '56px', 'important');
      btn.style.setProperty('font-weight', '800', 'important');
    };
    apply();
    new MutationObserver(apply).observe(btn, { attributes: true, attributeFilter: ['style'] });
    return true;
  }

  function initCodButton() {
    if (styleCodButton()) return;
    const mo = new MutationObserver(() => {
      if (styleCodButton()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 15000);
  }

  function init(root) {
    initEta(root);
    initSticky(root);
    initCodButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
